import { Routes } from '@angular/router';
import { environment } from '@environment';
import { createAuthenticatedRedirectGuard } from '@dvm-monorepo/frontend/guards/authenticated-redirect.guard';
import { userLocationsResolver } from '@app/features/user-locations/resolvers/user-locations.resolver';
import { selectedUserLocationResolver } from '@app/features/user-locations/resolvers/selected-user-location.resolver';
import { singleLocationRedirectResolver } from '@app/features/user-locations/resolvers/single-location-redirect.resolver';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'locations'
    },
    {
        path: 'locations',
        resolve: {
            userLocations: userLocationsResolver
        },
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('@app/features/user-locations/pages/location-selection.page').then(
                        c => c.LocationSelectionPage
                    ),
                resolve: {
                    singleLocationRedirect: singleLocationRedirectResolver
                }
            },
            {
                path: ':locationId/scan',
                loadComponent: () => import('@app/features/scan/pages/scan.page').then(c => c.ScanPage),
                resolve: {
                    selectedUserLocation: selectedUserLocationResolver
                }
            },
            {
                path: ':locationId/bookings',
                resolve: {
                    selectedUserLocation: selectedUserLocationResolver
                },
                loadChildren: () =>
                    import('@app/features/manual-check-in/manual-check-in.routes').then(r => r.manualCheckInRoutes)
            }
        ]
    },
    {
        path: environment.authentication.unauthorizedRoute,
        canActivate: [createAuthenticatedRedirectGuard()],
        loadComponent: () => import('@app/core/pages/unauthorized.page').then(c => c.UnauthorizedPage)
    }
];
